import { render, staticRenderFns } from "./AgentModal.vue?vue&type=template&id=365d412b&"
import script from "./AgentModal.vue?vue&type=script&lang=js&"
export * from "./AgentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365d412b')) {
      api.createRecord('365d412b', component.options)
    } else {
      api.reload('365d412b', component.options)
    }
    module.hot.accept("./AgentModal.vue?vue&type=template&id=365d412b&", function () {
      api.rerender('365d412b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/AgentModal.vue"
export default component.exports